import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, paramBuilder } from '../http';
export var createMembership = function createMembership() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var team = options.team,
      user = options.user;

  if (!team) {
    throw new Error('createMembership failed! The option "team" is required.');
  }

  if (!user) {
    throw new Error('createMembership failed! The option "user" is required.');
  }

  return axios.post("".concat(bundle.apiLocation(), "/memberships"), {
    team: team,
    user: user
  }, {
    params: paramBuilder(options)
  }).then(function (response) {
    return {
      membership: response.data.membership
    };
  })["catch"](handleErrors);
};
export var deleteMembership = function deleteMembership() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var teamSlug = options.teamSlug,
      username = options.username;

  if (!teamSlug) {
    throw new Error('deleteMembership failed! The option "teamSlug" is required.');
  }

  if (!username) {
    throw new Error('deleteMembership failed! The option "username" is required.');
  }

  return axios["delete"]("".concat(bundle.apiLocation(), "/memberships/").concat(teamSlug, "_").concat(username), {
    params: paramBuilder(options)
  })["catch"](handleErrors);
};